module.exports = __webpack_public_path__ + "media/images/flags/1x1/usa-a9b9934adb80a36cb9c586a43d829f42.svg";